module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Hazel.54b3aa3d.png";